import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { fmt } from "../../lib/format";
import { Spark } from "./Charts";
import { cn } from "../../lib/utils";

const statusRing = {
  good: "border-l-emerald-400",
  warn: "border-l-amber-400",
  critical: "border-l-red-400",
};

export function KpiCard({ k }) {
  const up = (k.change_pct ?? 0) >= 0;
  const lowerBetter = ["complaint_rate", "factory_capacity", "hub_capacity"].includes(k.key);
  const good = k.change_pct == null ? true : lowerBetter ? !up : up;
  return (
    <div
      className={cn(
        "bg-white border border-slate-200 rounded-lg p-4 border-l-2 hover:shadow-sm transition-[box-shadow] duration-200",
        statusRing[k.status] || "border-l-slate-300"
      )}
      data-testid={`kpi-${k.key}`}
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-medium text-slate-500">{k.label}</span>
        {k.target != null && <span className="text-[10px] text-slate-400">Target {fmt(k.target, k.format)}</span>}
      </div>
      <div className="flex items-end justify-between mt-2 gap-2">
        <div>
          <div className="kpi-num text-2xl font-extrabold text-slate-900 leading-none">{fmt(k.value, k.format)}</div>
          {k.change_pct != null ? (
            <div className={cn("flex items-center gap-0.5 mt-1.5 text-xs font-semibold", good ? "text-emerald-600" : "text-red-600")}>
              {up ? <ArrowUpRight className="w-3.5 h-3.5" /> : <ArrowDownRight className="w-3.5 h-3.5" />}
              {Math.abs(k.change_pct)}%
              <span className="text-slate-400 font-normal ml-1">vs prev</span>
            </div>
          ) : (
            <div className="text-xs text-slate-400 mt-1.5">current period</div>
          )}
        </div>
        <Spark data={k.trend} color={good ? "#88D317" : "#6E3667"} />
      </div>
    </div>
  );
}
